import { Button, Col, Form, Input, message, Row, Select } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import * as React from 'react';
import { IPageResult } from 'src/entity/BaseResult';
import { IDrugStoreInfo } from 'src/entity/DrugStoreEntity';
import { IDrugStoreSearch } from 'src/entity/SearchEntity';
import drugStoreService, { DrugStoreStatus } from 'src/services/DrugStoreService';
import i18n from 'src/services/I18NService';

interface IDrugStoreSearchFormProps extends FormComponentProps {
  onRef(obj: any): void;
  cbSearch(obj: IPageResult<IDrugStoreInfo[]>): void;
}

class DrugStoreSearchForm extends React.Component<IDrugStoreSearchFormProps> {
  constructor(props: IDrugStoreSearchFormProps) {
    super(props);
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  handleSearch = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.doSearch();
  };

  doSearch = (offset: number = 0, limit: number = 10) => {
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        try {
          let isActive;
          if (values.is_active !== undefined) {
            isActive = values.is_active === 'true';
          }
          const query: IDrugStoreSearch = {
            limit,
            offset,
            name: values.name,
            admin_mobile: values.admin_mobile,
            admin_email: values.admin_email,
            is_active: isActive,
          };
          const result: IPageResult<IDrugStoreInfo[]> = await drugStoreService.getDrugStore(query);
          if (!!result) {
            this.props.cbSearch(result);
          }
        } catch (error) {
          if (!!error.response) {
            message.error(JSON.stringify(error.response.data));
          } else {
            message.error(i18n.get('err_search_failure'));
          }
        }
      }
    });
  };

  handleReset = () => {
    this.props.form.resetFields();
  };

  getDrugStoreStatus = (): JSX.Element[] => {
    const options: JSX.Element[] = [];
    for (const option of DrugStoreStatus) {
      options.push(
        <Select.Option key={option.key} value={String(option.value)}>
          {i18n.get(option.key)}
        </Select.Option>
      );
    }
    return options;
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form className="mdd-search-form" onSubmit={this.handleSearch}>
        <Row type="flex" align="middle">
          <div className="auto-flex-item">
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item label={i18n.get('drug_store_name')} style={{ marginBottom: 0 }}>
                  {getFieldDecorator(`name`)(<Input placeholder={i18n.get('drug_store_name')} />)}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label={i18n.get('common_status')} style={{ marginBottom: 0 }}>
                  {getFieldDecorator(`is_active`)(
                    <Select placeholder={i18n.get('common_choose')} allowClear={true}>
                      {this.getDrugStoreStatus()}
                    </Select>
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24} style={{marginTop: 10}}>
              <Col span={8}>
                <Form.Item label={i18n.get('common_mobile')} style={{ marginBottom: 0 }}>
                  {getFieldDecorator(`admin_mobile`)(<Input placeholder={i18n.get('common_mobile')} />)}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="email" style={{ marginBottom: 0 }}>
                  {getFieldDecorator(`admin_email`)(<Input placeholder="email" />)}
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="fixed-flex-item flex-column" style={{marginLeft: 30}}>
            <Button type="primary" htmlType="submit">
              {i18n.get('common_search')}
            </Button>
            <Button style={{ marginTop: 16 }} onClick={this.handleReset}>
              {i18n.get('common_clear')}
            </Button>
          </div>
        </Row>
      </Form>
    );
  }
}

const DrugStoreSearch = Form.create<IDrugStoreSearchFormProps>()(DrugStoreSearchForm);
export default DrugStoreSearch;



// WEBPACK FOOTER //
// ./src/components/custom/DrugStoreSearch.tsx